import { useState, useEffect } from 'react';

function getIndiaDateTime() {
    const now = new Date();
    const options = {
        timeZone: 'Asia/Kolkata',
        hour: '2-digit',
        minute: '2-digit',
        hour12: true,
    };
    const dateOptions = {
        timeZone: 'Asia/Kolkata',
        day: '2-digit',
        month: 'long',
        year: 'numeric',
    };
    const time = now.toLocaleTimeString('en-IN', options);
    const date = now.toLocaleDateString('en-IN', dateOptions);
    return `${time} · ${date}`;
}

export default function Topbar({ isDark, onToggleTheme, onLogout, user, operatorDetails }) {
    const [dateTime, setDateTime] = useState(getIndiaDateTime());
    const isOperator = user?.userType === 'operator';

    useEffect(() => {
        const timer = setInterval(() => {
            setDateTime(getIndiaDateTime());
        }, 1000);
        return () => clearInterval(timer);
    }, []);

    return (
        <header className={`topbar ${isOperator ? 'operator-topbar' : ''}`}>
            <div className="topbar-left">
                {!isOperator && (
                    <div className="topbar-logo">
                        <span /><span /><span /><span /><span />
                    </div>
                )}
                {isOperator && (
                    <div className="topbar-back-btn">
                        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><polyline points="15 18 9 12 15 6"></polyline></svg>
                    </div>
                )}
                <div>
                    <div style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
                        <span className="topbar-brand">
                            Opsmaticz <span>- Fleet Management</span>
                        </span>
                    </div>
                    {!isOperator && <div className="topbar-meta">{dateTime}</div>}
                </div>
            </div>

            {isOperator && (
                <nav className="topbar-nav-horizontal">
                    <a href="#operator-dashboard" className="active">Dashboard</a>
                    <a href="#">News</a>
                    <a href="#">Support</a>
                    <a href="#">More</a>
                </nav>
            )}

            <div className="topbar-search">
                <div style={{ position: 'relative', display: 'flex', alignItems: 'center' }}>
                    <svg style={{ position: 'absolute', left: 10, color: '#94a3b8' }} width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="11" cy="11" r="8"></circle><line x1="21" y1="21" x2="16.65" y2="16.65"></line></svg>
                    <input placeholder="Search..." style={{ paddingLeft: 32 }} />
                </div>
            </div>

            <div className="topbar-actions">
                {isOperator && (
                    <>
                        <div className="topbar-icon-btn">🔔</div>
                        <div className="topbar-icon-btn">❓</div>
                        <div className="topbar-icon-btn">⚙️</div>
                        <button className="upgrade-btn">⭐ Upgrade</button>
                    </>
                )}

                {!isOperator && (
                    <div className="notif-btn">
                        🔔
                        <span className="notif-dot" />
                    </div>
                )}

                <div className="user-profile-mini">
                    <div className="user-avatar-small">{user?.firstName?.charAt(0) || 'U'}</div>
                    {!isOperator && (
                        <div className="user-details-mini">
                            <span className="u-name">{user?.firstName} {user?.lastName}</span>
                            <span className="u-role">{user?.role}</span>
                        </div>
                    )}
                </div>

                {!isOperator && (
                    <div
                        className={`toggle-btn ${isDark ? 'toggle-dark' : 'toggle-light'}`}
                        onClick={onToggleTheme}
                        title={isDark ? 'Switch to Light Mode' : 'Switch to Dark Mode'}
                    >
                        <span className="toggle-icon">{isDark ? '🌙' : '☀️'}</span>
                        <div className="toggle-track">
                            <div className="toggle-thumb" />
                        </div>
                    </div>
                )}

                <button className="logout-btn-top" onClick={onLogout} title="Logout">
                    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                        <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4" />
                        <polyline points="16 17 21 12 16 7" />
                        <line x1="21" y1="12" x2="9" y2="12" />
                    </svg>
                </button>
            </div>
        </header>
    );
}
